.cg{right:0px;}